import React from 'react';
import { Overlay, Spinner } from './styles';

const LoadingSpinner: React.FC = () => {
  return (
    <Overlay>
      <Spinner />
    </Overlay>
  );
};

export default LoadingSpinner;
